let declOfNum = (number, titles) => {
  // 0, 5, 10, 19 => titles[2]
  // 1, 21 => title[0]
  // 2, 3, 4 => title[1]

  number = Math.abs(Number(number));
  let cases = [2, 0, 1, 1, 1, 2];
  return titles[ (number%100>4 && number%100<20)? 2 : cases[(number%10<5)?number%10:5] ];
};

export default declOfNum;